import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import NewsLetterSubscription from './newsletterSubscription';
import FooterLinks from './footerLinks';
import Contact from './contact';

const Footer = () => {
  const { configuration } = useStaticQuery(
    graphql`
      query FooterQuery {
        configuration: allStoryblokEntry(
          filter: { field_component: { eq: "configuration_footer" } }
        ) {
          edges {
            node {
              content
              lang
            }
          }
        }
      }
    `,
  );

  const res = configuration.edges.find(
    (n) => n.node.lang === process.env.GATSBY_STORYBLOK_LANGUAGE,
  );

  const content = JSON.parse(res.node.content);

  return (
    <footer className="mt-12">
      <Contact content={content} />
      <NewsLetterSubscription content={content} />
      <FooterLinks content={content} />
    </footer>
  );
};

export default Footer;
